import { Model } from "pinia-orm";
import Contributor from "./Contributor";
import ContributorBatch from "./ContributorBatch";
import Company from "./Company";

export class DefaultBatch extends Model {
  /*
  Corresponding to Batch model in backend.
  Used as base batch, they will be display as choice
  to user for defining Batches.
  */
  static name = "DefaultBatch";
  static entity = "defaultBatches";
  static primaryKey = "uuid";
  static fields() {
    return {
      uuid: this.uid(),
      batchLabel: this.attr(),
    };
  }
}
export class Batch extends Model {
  /*
  Corresponding to CustomizedBatch model in backend.
  These batches are those defined by the user and
  effectively linked to the project.
  */
  static name = "Batch";
  static entity = "batches";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(),
      objectId: this.attr(),
      overridedLabel: this.attr(),
      code: this.attr(),
      contributors: this.belongsToMany(Contributor, ContributorBatch, "batchId", "contributorId"),
      entreprise: this.hasOne(Company, "batchUuid"),
    };
  }
  get labelWithCode() {
    const displayCode = `${this.code}`;
    return displayCode.length > 0 ? `${displayCode} ${this.overridedLabel}` : this.overridedLabel;
  }
}
